// Selection identity, not a content checksum. Used only for packing uploads;
// distinct files with the same name are still allowed through a saved-name nudge.
export const packingFileSelectionKey = (file: File) =>
  JSON.stringify([file.name, file.size, file.lastModified, file.type]);

const comparableFileName = (name?: string) => name?.normalize('NFC').trim().toLowerCase() ?? '';

export const hasSavedPackingFileName = (name: string, assets: ReadonlyArray<{ name?: string }>) => {
  const comparable = comparableFileName(name);
  return Boolean(comparable) && assets.some(asset => comparableFileName(asset.name) === comparable);
};
